angular.module('festzelt-os.modules.documents', [
    'festzelt-os.components'
]);

require('./services/document-create-service');



// WEBPACK FOOTER //
// ./src/app/modules/documents/module.js